import { render } from "./ReferralPage.vue?vue&type=template&id=59ecf59c&scoped=true"
import script from "./ReferralPage.vue?vue&type=script&lang=js"
export * from "./ReferralPage.vue?vue&type=script&lang=js"

import "./ReferralPage.vue?vue&type=style&index=0&id=59ecf59c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ecf59c"]])

export default __exports__